export default __webpack_public_path__ + "static/media/bk.76756edd.jpeg";